import {
  Avatar,
  AvatarSkeleton,
  CbhIcon,
  iconSizeByAvatarSize,
} from "@src/appV2/redesign/system/ui-components";
import { type AvatarSize } from "@src/appV2/redesign/system/ui-theme";

interface WorkplaceAvatarProps {
  size?: AvatarSize;
  pictureUrl?: string;
  isLoading?: boolean;
}

export function WorkplaceAvatar(props: WorkplaceAvatarProps) {
  const { size = "medium", pictureUrl, isLoading } = props;

  if (isLoading) {
    return <AvatarSkeleton size={size} />;
  }

  return (
    <Avatar src={pictureUrl} size={size}>
      <CbhIcon type="building" size={iconSizeByAvatarSize[size]} />
    </Avatar>
  );
}
